import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, throwError, map } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PromptService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/api/prompt`;

  getPromptOptions(): Observable<any[]> {
    return this.http.get<any>(`${this.apiUrl}/options`).pipe(
      map(response => response.data),
      catchError((error) => {
        console.error('[PromptService] GET prompt/options request failed', error);
        return throwError(() => error);
      })
    );
  }

  getPromptSandbox(typeId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/sandbox/type/${typeId}`).pipe(
      map(response => response.data),
      catchError((error) => {
        console.error('[PromptService] GET prompt/sandbox/type request failed', error);
        return throwError(() => error);
      })
    );
  }

  getVoiceTranscriptions(typeId: number, page: number = 1, perPage: number = 15): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('per_page', perPage.toString())
      .set('duration', '90');

    return this.http.get<any>(`${environment.apiUrl}/api/voice-transcriptions/type/${typeId}`, { params }).pipe(
      catchError((error) => {
        console.error('[PromptService] GET voice-transcriptions request failed', error);
        return throwError(() => error);
      })
    );
  }

  createPromptSandbox(typeId: number): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/api/new/beta/prompt`,
      { agent_type_id: typeId, content: 'Contenido del prompt beta...' }
    ).pipe(
      map(response => response.data),
      catchError((error) => {
        console.error('[PromptService] POST prompt/sandbox/type request failed', error);
        return throwError(() => error);
      })
    );
  }

  savePromptSandbox(promptId: number, minScore: string, documentContent: string): Observable<any> {
    return this.http.put<any>(
      `${environment.apiUrl}/api/beta/prompt/${promptId}`,
      { min_score: +minScore, content: documentContent }
    ).pipe(
      map(response => response.data),
      catchError((error) => {
        console.error('[PromptService] PUT prompt/sandbox/type request failed', error);
        return throwError(() => error);
      })
    );
  }

  testPrompt(promptId: number, voiceTranscriptionId: number, content: string, min_score: string): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/api/test/prompt/${promptId}/voice-transcription/${voiceTranscriptionId}`,
      { content, min_score }
    ).pipe(
      map(response => response.data),
      catchError((error) => {
        console.error('[PromptService] POST test/prompt request failed', error);
        return throwError(() => error);
      })
    );
  }

  getStatusTest(processId: number, processProdId?: number): Observable<any> {
    let url = `${environment.apiUrl}/api/prompt/status/test/process/${processId}`;
    if (processProdId) {
      url += `/prod/${processProdId}`;
    }
    return this.http.get<any>(
      url,
    ).pipe(
      map(response => response.data),
      catchError((error) => {
        console.error('[PromptService] GET status test prompt request failed', error);
        return throwError(() => error);
      })
    );
  }
}
